export const newRelicLogger = (level, message, args) => {
    try {
        const error = level && level.toLowerCase() === 'error';
        if (error && window.NREUM) {
            var errorMessage = message + ' ' + window.JSON.stringify(args);
            window.NREUM.noticeError(errorMessage);
        }
        if (window && window.console) {
            if (error && window.console.error) {
                window.console.error(message, args);
            }
            else {
                window.console.log(message, args);
            }
        }
    }
    catch (e) {
        // ¯\_(ツ)_/¯
    }
};
